import { Typography, Paper, Container } from "@mui/material";
import { contactInformation } from "../context/contactInformation";


function Contact() {
  const name = contactInformation.name
  const email = contactInformation.email
  const phone = contactInformation.phone

  return (
    <Container>
      <Paper sx={{ padding: 4 }}>
        <Typography marginBottom={2} variant='h4'>Contact</Typography>

        <Typography >
          Contact person for question, feedback, objections:
        </Typography>
        <ul>
          <li>
            Name: {name}
          </li>
          <li>
            Phone: {<a href={'tel:' + phone}>{phone}</a>}
          </li>
          <li>
            Email: {<a href={'mailto:' + email}>{email}</a>}
          </li>
        </ul>
      </Paper>
    </Container>
  )
}
export default Contact;